import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Table as CommonTable } from '../../../../../common/table'
import { getCellStyleByColId } from '../../common/helper'
import {
  getNoDataComponent,
  handleIconDownload,
  renderTd,
  sortKeySchemaTable,
} from '../../helper'
import {
  selectByIdTable,
  selectCell,
  selectIdTable,
  selectIndicatorById,
  selectYears,
} from './store/slice'

const Table = ({ isDynamicReport, id, checkTable }) => {
  let ids = useSelector(selectIdTable)
  const years = useSelector(selectYears)

  const tableSchema = {
    UNIT: 'unit',
    RATIO_NAME: 'ratioName',
  }

  years.forEach((year) => (tableSchema[String(year)] = String(year)))

  const isNoData = !years.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (isDynamicReport) {
    ids = ids.filter((id) => checkTable.includes(id))
  }

  return (
    <div className="h100">
      {isNoData ? (
        getNoDataComponent(isDynamicReport)
      ) : (
        <CommonTable
          ids={ids}
          isDisplayScroll={!isDynamicReport}
          isNoStickyHead={isDynamicReport}
          columnDraggable={false}
          getDataFromRedux={selectCell}
          isLoading={false}
          rowDraggable={false}
          hasFooter={false}
          resizable={false}
          schema={sortKeySchemaTable(Object.keys(tableSchema)).map((key) => {
            const title = `financialAnalysis.${key}`
            const colId = tableSchema[key]
            return {
              colId,
              title,
              isI18n: true,
              ...getCellStyleByColId(colId),
              render: renderTd(selectByIdTable, selectIndicatorById),
            }
          })}
        />
      )}
    </div>
  )
}

export default Table
